import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import 'vue-select/dist/vue-select.css';
import SessionTable from '@activities/components/tables/activity-session-table/activity-session-table.vue';
import { ActivitySession } from '@activities/interfaces/activity-session';

@Component({
  name: 'bpc-activity-session-table-input',
  components: {
    'bpc-activity-session-table': SessionTable,
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class AttendeeTableInput extends mixins(AbstractField) {
  declare $refs: AbstractField['$refs'] & {
    sessionTable: InstanceType<typeof SessionTable> & {
      getEntities(): void;
    };
  };
  @Prop(Array) readonly value: any[];
  @Prop(Object) readonly externalFormModel: object;

  @Prop({ type: String, default: 'drawer' }) readonly type: string;
  @Prop(String) readonly selectEntity: string;

  @Prop(Array) readonly filters: any[];
  @Prop(String) readonly fieldForStorage: string;

  @Prop(Boolean) readonly withDraft: boolean;
  @Prop({ type: String, default: 'default' })
  readonly formConfigName: string;
  @Prop({ type: String, default: 'edit' })
  readonly editFormConfigName: string;
  @Prop({
    type: Array,
    default: () => {
      return ['default'];
    },
  })
  readonly selectConfigName: string[];
  @Prop({ type: Boolean, default: false }) readonly showTableHeader: boolean;
  @Prop({ type: Boolean, default: false }) readonly withSearch: boolean;
  @Prop({ type: Boolean, default: false }) readonly withFilters: boolean;
  @Prop({ type: Boolean, default: false }) readonly showPagination: boolean;
  @Prop({ type: Boolean, default: false }) readonly showTabFilters: boolean;
  @Prop({ type: Boolean, default: false }) readonly showOrderBy: boolean;
  @Prop({ type: Boolean, default: false }) readonly showCalendar: boolean;
  @Prop({ type: String, default: 'table' }) readonly typeOfDisplay: string;

  @Prop({
    type: Array,
    default: () => ['configLoaded', 'paginationLoaded', 'orderLoaded'],
  })
  readonly customFlagsToCheckBeforeLoadEntities: Array<any>;
  @Prop({ type: String, default: 'table-input' }) readonly displayConfigName: string;
  @Prop({ type: String, default: 'default' }) readonly filterConfigName: string;

  get model(): any[] {
    return this.value;
  }
  set model(val: any[]) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  mounted() {
    this.$root.$on('activityOfGroupChangedFromTableInput', () => {
      this.$refs.sessionTable?.onRefresh();
    });
  }

  destroyed(): void {
    this.$root.$off('activityOfGroupChangedFromTableInput');
  }

  public entity: ActivitySession = null;
  public entityName = 'activity-session';
  public pluralEntityName = 'activity-sessions';
  public permissionEntityNameToUse = 'activity_session';

  displayConfigNameToUse: string;
  filtersToUse;
  tableKey: number = 1;

  //  Computed
  get tenantType(): string {
    return this.$store.getters['centerSettings/centerSettings']['center_type'] || 'center';
  }
  get mode(): string {
    return 'api';
  }

  created() {
    this.displayConfigNameToUse = this.displayConfigName;
    this.filtersToUse = this.filters;
  }

  // Methods
  getEntities() {
    return this.$refs.sessionTable?.getEntities();
  }

  onChange($event) {
    this.$emit('change', $event);
  }

  onLoadPastSessions() {
    this.displayConfigNameToUse = 'past-sessions-for-table-input';
    this.filtersToUse = [
      ...this.filters,
      {
        filterField: 'period',
        modelField: 'period',
        value: 'past',
      },
    ];
    this.tableKey++;
  }
  onLoadUpcomingSessions() {
    this.displayConfigNameToUse = 'upcoming-sessions-for-table-input';
    this.filtersToUse = [
      ...this.filters,
      {
        filterField: 'period',
        modelField: 'period',
        value: 'upcoming',
      },
    ];
    this.tableKey++;
  }
  onLoadDefaultSessions() {
    this.displayConfigNameToUse = this.displayConfigName;
    this.filtersToUse = this.filters;
    this.tableKey++;
  }
}
